import styled from 'styled-components'

import { CheckPicker as CheckPickerComponent } from '@avantstay/backoffice-core'

export const CheckPicker = styled(CheckPickerComponent.Small)`
  min-width: 150px;
`
